<script>
import formatGender from "@utils/format-gender";
import { merchantComputed } from "@store/helpers";
import formatPrice from "@utils/format-price";
import {
  orderAtmInfoList,
  orderInfoList,
  orderIsCanPay,
  orderIsOffline,
  orderIsUseDeduct,
  orderPetInfoList,
  orderIsPrepaidUnpaidAndDeduct,
  orderVaccInfoList,
  orderBillingReservationList,
  orderReservationInfoList,
  orderReserveParamsList
} from "@utils/ipetbooking-order";

export default {
  components: {
    OrderPaymentButton: () => import("@components/Order/OrderPaymentButton"),
  },
  props: {
    orderItem: {
      type: Object,
      default: () => {
        return {}
      }
    },
    containerItem: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    ...merchantComputed,
    couponDiscount() {
      return this.orderItem.coupon.discountValue > this.orderItem.priceBase
        ? this.orderItem.priceBase
        : this.orderItem.coupon.discountValue;
    },
    hasExtrafieldsByOrder() {
      const orderExtrafields = this.orderItem.byOrderExtrafields || {};

      return !!Object.keys(orderExtrafields)[0];
    },
    hasExtrafields() {
      return this.hasExtrafieldsByOrder
    },
    isOffline() {
      return orderIsOffline({
        order: this.orderItem,
        ordertype: 'order',
        type: 'reservation'
      });
    },
    priceTotal() {
      const ordersListTotal = this.containerItem.orders.items.reduce((previousValue, currentValue) => {
        return previousValue + currentValue.priceTotal
      }, 0);
      const paramsListTotal = this.containerItem.params.reduce((previousValue, currentValue) => {
        return previousValue + currentValue.total
      }, 0);
      return ordersListTotal + paramsListTotal
    },
    isUseDeduct() {
      return orderIsUseDeduct({ ...this.orderItem })
    },
    isUnpaidAndDeduct() {
      return orderIsPrepaidUnpaidAndDeduct({ ...this.orderItem })
    },
    orderBillingList() {
      return orderBillingReservationList({
        type: 'memberOrder',
        ...this.orderItem,
        isUnpaidAndDeduct: this.isUnpaidAndDeduct
      });
    },
    orderInfoList() {
      return orderInfoList({ ...this.containerItem, isContainer: true });
    },
    reservationInfoList() {
      return orderReservationInfoList({ ...this.containerItem });
    },
    vaccInfoList() {
      return orderVaccInfoList({ ...this.containerItem, unpaid: this.priceTotal })
    },
    atmInfoList() {
      return orderAtmInfoList({ ...this.containerItem, unpaid: this.priceTotal })
    },
    petInfoList() {
      return orderPetInfoList({ ...this.orderItem });
    }
  },
  methods: {
    orderIsCanPay,
    formatPrice,
    reservationParamsList(params) {
      const paramsList = (typeList) => {
        return orderReserveParamsList({
          typeList,
          params : params,
        });
      };
      // console.log(paramsList(['cosmetic']))
      return paramsList(['cosmetic','daycare','daycare-add','cosmetic-add'])
    },
  }
}
</script>
<!-- section template -->
<template>
  <div :class="$style.reservationItemSectionItemDetail">
    <ul :class="[$style.detailList, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
      <li
        v-if="!!orderBillingList[0]"
        class="detailList__item"
      >
        <div class="row">
          <div class="col-md-3">
            <div class="detailList__title">
              服務項目
            </div>
          </div>
          <div class="col-md-9">
            <ul :class="$style.reservationParamsList">
              <li v-for="(item,$index) in reservationParamsList(orderItem.params)" :key="$index">
                {{ item.title }}
              </li>
            </ul>
            <!-- <BaseList
              :data-list="orderBillingList"
              type="info"
            /> -->
          </div>
        </div>
      </li>
      <li
        v-if="!!orderInfoList[0]"
        class="detailList__item"
      >
        <div class="row">
          <div class="col-md-3">
            <div class="detailList__title">
              訂單資訊
            </div>
          </div>
          <div class="col-md-9">
            <BaseList
              :data-list="orderInfoList"
              type="info"
            />
          </div>
        </div>
      </li>
      <li
        v-if="(containerItem.paymentMethod === 'Vacc' && !!vaccInfoList[0]) || containerItem.paymentMethod === 'Atm' && !!atmInfoList[0]"
        class="detailList__item"
      >
        <div class="row">
          <div class="col-md-3">
            <div class="detailList__title">
              匯款資訊
            </div>
          </div>
          <div class="col-md-9">
            <BaseList
              v-if="containerItem.paymentMethod === 'Vacc' && !!vaccInfoList[0]"
              :data-list="vaccInfoList"
              type="info"
            />
            <BaseList
              v-if="containerItem.paymentMethod === 'Atm' &&  !!atmInfoList[0]"
              :data-list="atmInfoList"
              type="info"
            />
          </div>
        </div>
      </li>
      <li
        v-if="!!reservationInfoList[0] && orderItem.type !== 'goods'"
        class="detailList__item"
      >
        <div class="row">
          <div class="col-md-3">
            <div class="detailList__title">
              預約資訊
            </div>
          </div>
          <div class="col-md-9">
            <BaseList
              :data-list="reservationInfoList"
              type="info"
            />
          </div>
        </div>
      </li>
      <li
        v-if="orderItem.byOrderExtrafields && orderItem.type !== 'goods'"
        class="detailList__item"
      >
        <div class="row">
          <div class="col-md-3">
            <div class="detailList__title">
              服務資訊
            </div>
          </div>
          <div class="col-md-9">
            <div :class="$style.extrafieldList">
              <div
                v-for="(extrafield, id) in orderItem.byOrderExtrafields"
                :key="id"
                class="extrafieldList__item"
              >
                <div
                  class="extrafieldList__title"
                  v-text="extrafield.title"
                ></div>
                <div
                  class="extrafieldList__text"
                  v-text="extrafield.value ? `A: ${extrafield.value}` : '----'"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li v-if="orderItem.type === 'goods'"
        class="detailList__item"
      >
        <div class="row">
          <div class="col-md-3">
            <div class="detailList__title">
              寄送資訊
            </div>
          </div>
          <div class="col-md-9">
            <div :class="$style.extrafieldList">
              <div class="extrafieldList__item">
                <div class="extrafieldList__title">姓名：</div>
                <div class="extrafieldList__text">{{containerItem.shippingInfo ? containerItem.shippingInfo.name : ""}}</div>
              </div>
              <div class="extrafieldList__item">
                <div class="extrafieldList__title">聯絡電話：</div>
                <div class="extrafieldList__text">{{containerItem.shippingInfo ? containerItem.shippingInfo.phone : ""}}</div>
              </div>
              <div class="extrafieldList__item">
                <div class="extrafieldList__title">寄送地址：</div>
                <div class="extrafieldList__text">{{containerItem.shippingInfo ? containerItem.shippingInfo.city + containerItem.shippingInfo.district + containerItem.shippingInfo.address : ""}}</div>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <!-- <template v-if="isUseDeduct">
      <OrderPaymentButton
        :order-item="containerItem"
        type="deduct"
        button-class="mt-5"
      />
    </template> -->
    <template>
      <OrderPaymentButton
        :order-item="containerItem"
        type="reservation"
        button-class="mt-5"
      />
    </template>
    <!-- <BasePre>{{ orderItem }}</BasePre> -->
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.reservationItemSectionItemDetail {
  // color: $color-text;
  :global {
    .reservationItemSectionItemDetail {
      @include unstyled;
    }
  }
}

.detailList {
  @include list-unstyled;

  margin: 0 0 2rem;

  :global {
    .detailList {
      &__item {
        color: $color-gray-2;
        // font-size: 0.875rem;
        &:not(:last-child) {
          padding-bottom: 2rem;
          border-bottom: 1px solid $color-line;
        }

        &:not(:first-child) {
          padding-top: 2rem;
        }

        &.isTitle {
          padding: 1.5rem;
          background: rgba($color-secondary, 0.1);
          border-bottom: unset;
        }
      }

      &__title {
        @extend %FontSerifWeightJtails;

        @include max-md {
          margin-bottom: 1.5rem;
          // font-weight: 500;
          // color: $color-blue-dark;
        }
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .detailList {
        &__title {
          font-family: unset;
          font-weight: 400;
          color: $color-secondary;
        }
      }
    }
  }
}

.extrafieldList {
  margin: -0.5rem 0;
  line-height: 2;

  :global {
    .extrafieldList {
      &__item {
        padding: 0.5rem 0;

        @include max-md {
          font-size: 0.75rem;
        }
      }

      &__title {
        @include unstyled;
      }

      &__text {
        color: $color-gray-2;
      }
    }
  }
}

.reservationParamsList {
  @include list-unstyled; 
  min-height: 4rem;
  li {
    :not(:last-child) {
      margin-bottom: 1rem;
    }
  }
}
</style>
